shadow$provide[315] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Types:{enumerable:true, get:function() {
  return Types;
}}});
var require$_DOT__SLASH_types = require("./types");
const Types = require$_DOT__SLASH_types.Types;

};